import { useState, useCallback } from "react";
import { Button, Flex } from "@theorgchartdev/storybook";
import SectionCard from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import { GetWSMgr } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { copyTextToClipboardNoEvent } from "@coreapp/utils/copyTextToClipboardNoEvent";
import { useToast, TOAST_STATUS } from "@/providers/ToastProvider";
import PasteViewsModal from "../../../PasteViewsModal/PasteViewsModal";
import { buildCopyPayload } from "../../../PasteViewsModal/resolvePastePayload";

export const CopyPasteViewsSection = () => {
  const [showPasteModal, setShowPasteModal] = useState(false);
  const { addToast }: any = useToast();

  const handleCopy = useCallback(() => {
    const wsMgr = GetWSMgr();
    if (!wsMgr) return;

    const ctMgr = wsMgr.GetChartTemplatesMgr();
    const bsMgr = wsMgr.GetBoxStylesMgr();
    if (!ctMgr || !bsMgr) return;

    const payload = buildCopyPayload(ctMgr, bsMgr);
    copyTextToClipboardNoEvent(JSON.stringify(payload));

    addToast?.({
      message: appstr("Views and box styles copied to your clipboard."),
      status: TOAST_STATUS.SUCCESS
    });
  }, [addToast]);

  const handleOpenPasteModal = useCallback(() => {
    setShowPasteModal(true);
  }, []);

  const handleClosePasteModal = useCallback(() => {
    setShowPasteModal(false);
  }, []);

  return (
    <>
      <SectionCard
        title={appstr("Export views and box styles")}
        data-testid="copy-paste-views-section"
      >
        <Flex gap="16px">
          <Button
            modifier="secondary"
            size="medium"
            onClick={handleCopy}
            data-testid="copy-paste-views-copy-btn"
            data-pendo-id="account-settings-theme-copy-views-btn"
            iconAlignEnd
            iconProps={{ name: "copy" }}
          >
            {appstr("Copy to clipboard")}
          </Button>
          <Button
            modifier="secondary"
            size="medium"
            onClick={handleOpenPasteModal}
            data-testid="copy-paste-views-paste-btn"
            data-pendo-id="account-settings-theme-paste-views-btn"
            iconAlignEnd
            iconProps={{ name: "paste" }}
          >
            {appstr("Paste from clipboard")}
          </Button>
        </Flex>
      </SectionCard>
      <PasteViewsModal show={showPasteModal} onClose={handleClosePasteModal} />
    </>
  );
};

export default CopyPasteViewsSection;
